<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
 <div [ngClass]="{ 'readonly': ReadOnly == true  }">
<div *ngIf="getWaitingForcallStatus(); else showDialerSection"><!--*ngIf="connections; else showDialerSection"-->
  <p-dialog
    id="dialog"
    [(visible)]="visible"
    [showHeader]="false"
    [position]="position"
    [breakpoints]="{ '60rem': '75vw' }"
    [style]="{ 'max-height': '5rem', top: '0px' }"
    [breakpoints]="{ '960px': '75vw' }"
    [style]="{ 'max-height': '150px', width: '12.5rem', 'border-radius': '5px','overflow' :'hidden'}"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    #dialog
  >
    <!-- <div id="dialog" [style]="{ 'max-height': '5rem','padding':'5px' }" *ngIf="visible" #dialog> -->
    <div class="row">
      <div class="col-2">
        <img alt="" src="{{ baseHref }}/assets/images/icon-phone-connecting.svg" />
      </div>

      <div class="text">
        {{ dialerMessage }}
      </div>
    </div>
    <div class="cancelbtn">
      <button class="btnCancel" (click)="showstatusMenu()">
        <div class="inner-text">Cancel</div>
      </button>
    </div>
    <!-- </div> -->
  </p-dialog>
</div>
<!-- [style]="{'max-width': '11.25rem','height': '18.75rem'}"  -->
<!-- [style]="{'max-width': '180px','height': '300px'}"  -->
<!-- [styleClass]="show-keypad"
[ngStyle]="{'height': (keypad==true) ? '16.875rem' : '6.25rem'}" -->
<ng-template #showDialerSection> 
  <div *ngIf="getShowDialerStatus(); else callSummarySection"><!--*ngIf="showDialer; else callSummarySection"-->
    <!-- <p-dialog
      id="dialog"
      [(visible)]="visible"
      [showHeader]="false"
      [position]="position"
      [breakpoints]="{}"
      [draggable]="true"
      [resizable]="false"
      #dialog
    > -->
    <div id="dialog" *ngIf="visible" #dialog>
      <div class="call dial">
        <div class="Inbound">{{ getCallStatus() }}</div>
        <table class="t1">
          <tr>
            <td>
              <div class="number">
                {{ phoneNo }}
              </div>
            </td>
            <td>
                <div class="duration" *ngIf="getcallDuratonStatus() > 0">
                    {{ getformattedCallDurationStatus() }}
                </div>
            </td>
          </tr>
        </table>
        <table class="t2">
          <tr>
            <!--src="{{baseHref}}/assets/images/icon-mute.svg"-->
            <td>
              <!-- <button [disabled]="!holdbtn_enabled"> -->
              <div
                class="img-btn img-hold"
                alt="Hold"
                [title]="getonHold() ? 'Resume' : 'Hold'"
                [ngClass]="{ disabled: !holdbtn_enabled, active: getonHold() }"
                (click)="togglehold()"
              ></div>
              <!-- *ngIf="!getonHold()" -->
              <!-- </button> -->
              <!--<i ></i>-->
              <!-- <button
                *ngIf="!getonHold()"
                class="bi bi-pause"
                [disabled]="!holdbtn_enabled"
                style="-webkit-text-stroke: 0.063rem"
                (click)="togglehold()"
                title="Hold"
              ></button> -->
              <!-- <i *ngIf="onHold" class="bi bi-slash-lg" style="position: absolute;
                              left: 0.5rem;
                              rotate: 90deg;"></i> -->
              <!--<i ></i>-->
              <!-- <button
                *ngIf="getonHold()"
                class="bi bi-play"
                [disabled]="!holdbtn_enabled"
                title="Resume"
                (click)="togglehold()"
              ></button> -->
            </td>
            <td style="text-align: center" id="btnMute">
              <div
                class="img-btn img-mute"
                alt="Mute/Unmute"
                [title]="isMicMute ? 'Unmute' : 'Mute'"
                [ngClass]="{ disabled: !mutebtn_enabled || getonHold(), active: isMicMute }"
                (click)="mute(isMicMute)"
              ></div>
              <!-- *ngIf="!getonHold()" -->
              <!-- <button [disabled]="!mutebtn_enabled" (click)="mute(isMicMute)">
      <img
        src="{{ baseHref }}/assets/images/icon-mute.svg"
        class="mute"
        *ngIf="!isMicMute"
        title="Mute"
        alt="Mute Mic"
      />
      <img
        src="{{ baseHref }}/assets/images/icon-unmute.png"
        class="unmute"
        *ngIf="isMicMute"
        alt="UnMute Mic"
      />
      < ! --(click)="unmute()" - - >
    </button> -->
            </td>
            <td>
              <div
                id="btnReject"
                class="img-btn img-call-end"
                alt="End Call"
                title="Hangup"
                [ngClass]="{ disabled: !hangupbtn_enabled }"
                (click)="hangUp()"
              ></div>
              <!-- <button [disabled]="!hangupbtn_enabled">
                <img alt="" src="{{ baseHref }}/assets/images/icon-call-end.svg" alt="End Call" title="Hangup" />
              </button> -->
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="img-btn img-transfer"
                alt="Call Transfer"
                title="Transfer"
                [ngClass]="{ disabled: !transferbtn_enabled, active: isTransferwindowActive }"
                (click)="transferCall(isTransferwindowActive)"
              ></div>
              <!-- <button [disabled]="!transferbtn_enabled">
                <img
                  alt=""
                  src="{{ baseHref }}/assets/images/icon-call-forwarded.svg"
                  alt="call Transfer"
                  title="Transfer"
                />
              </button> -->
            </td>
            <td>
              <div
                class="img-btn img-conference"
                alt="Conference"
                title="Conference calls"
                [ngClass]="{ disabled: !conferencebtn_enabled, active: isConferencewindowActive }"
                (click)="showConferenceParticipant(isConferencewindowActive)"
              ></div>
              <!-- <button [disabled]="!conferencebtn_enabled">
                <img
                  alt=""
                  src="{{ baseHref }}/assets/images/icon-conference.svg"
                  alt="Conference"
                  title="Conference calls"
                />
              </button> -->
            </td>
            <td>
              <div
                class="img-btn img-dialer"
                alt="Dialer"
                title="Keypad"
                [ngClass]="{ disabled: !dialbtn_enabled, active: isKeyboardActive }"
                (click)="showKeypad(isKeyboardActive)"
              ></div>
              <!-- <button [disabled]="!dialbtn_enabled">
                <img alt="" src="{{ baseHref }}/assets/images/icon-dilaer.svg" alt="Dial" title="Keypad" />
              </button> -->
            </td>
          </tr>
          <tr class="keypad-row">
            <div *ngIf="keypad">
              <ng-container *ngFor="let item of numberPad">
                <div class="keypad" (click)="onNumberPadBtnClick(item.number)">
                  <div class="digits">{{ item.digit }}</div>
                  <div class="numbers">{{ item.number }}</div>
                </div>
              </ng-container>
            </div>
          </tr>
        </table>
      </div>
    </div>
    <!-- </p-dialog> -->
  </div>
  <ng-template #callSummarySection>
        <div *ngIf="getshowCallDurationStatus(); else defaultDialerReady"><!--*ngIf="callDisconnected; else defaultDialerReady"-->
      <!-- <p-dialog
        id="dialog"
        class="call"
        [(visible)]="visible"
        [showHeader]="false"
        [position]="position"
        [breakpoints]="{ '60rem': '75vw' }"
        [style]="{ 'max-height': '3.375rem' }"
        [draggable]="false"
        [resizable]="false"
        #dialog
      > -->
      <div id="dialog" class="call" [style]="{ 'max-height': '3.375rem', padding: '5px' }" *ngIf="visible" #dialog>
        <div class="row" (click)="EnableDialOption()">
          <div class="col-8" style="padding-right: 0 !important">
            <div class="status-info">Ready</div>
            <div
              style="
                text-align: left;
                font-weight: 500;
                font-size: 0.75rem;
                line-height: 1rem;
                font-family: Gellix, sans-serif;
                letter-spacing: 0rem;
                color: #000048;
                padding-top: 0.313rem;
              "
            >
              Call Duration <b>{{ getformattedCallDurationStatus() }}</b>
            </div>
          </div>
          <div class="col-4" style="padding-left: 0 !important">
            <img
              class="img-fluid"
              src="{{ baseHref }}/assets/images/icon-dial-call-inactive.svg"
              alt="Call"
            />
          </div>
        </div>
        <!-- </p-dialog> -->
      </div>
    </div>
    <ng-template #defaultDialerReady>
      <!-- <p-dialog
        id="dialog"
        class="call"
        [(visible)]="visible"
        [showHeader]="false"
        [position]="position"
        [breakpoints]="{ '60rem': '75vw' }"
        [style]="{ 'max-height': '3.375rem' }"
        [draggable]="false"
        [resizable]="false"
        #dialog
      > -->
      <div *ngIf="EnableFreePhone">
        <div id="dialog" class="call" *ngIf="visible" #dialog>
          <div class="row">
            <div class="col-7 pe-0">
              <div class="status-info">Ready</div>
              <div>
                <input
                
                  [(ngModel)]="OutBoundNumber"
                  placeholder="Type Here.."
                  (keyup)="ValidateOutboundNumber($event.target)"
                  type="text"
                  id="OutBoundNumber"
                  (keydown.enter)="StartFreeDialOutbound()"
                  #phoneInput
                />
              </div>
            </div>
            <div class="col-5 p-0">
              <img
                class="img-fluid"
                style="padding-left: 0.625rem"
                src="{{ baseHref }}/assets/images/icon-dialer-contact-book-inactive.svg"
                alt="Contact Book"
                (click)="openModal()"
              />
              <ng-container *ngIf="isCallEnabled; else DisabledCallActivity">
                <img
                  class="img-fluid c-pointer"
                  src="{{ baseHref }}/assets/images/icon-dial-call-green-reverse.svg"
                  alt="Call"
                  (click)="StartFreeDialOutbound()"
                />
              </ng-container>
              <ng-template #DisabledCallActivity>
                <img
                  class="img-fluid"
                  src="{{ baseHref }}/assets/images/icon-dial-call-inactive.svg"
                  alt="Call"
                />
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- soft phone model popup start -->
      <div *ngIf="false">
        <div id="dialog" class="call" *ngIf="visible" #dialog>
          <div class="row">
            <div class="col-12 pe-0">
              <div class="soft-phone-info text-center"> The soft phone is starting up.<br />Please wait...</div>
            </div>
           
          </div>
        </div>
      </div>

      <!-- soft phone model end -->

        <!-- wrong/invalid number model popup start -->
      <div *ngIf="false">
        <div id="dialog" class="call" *ngIf="visible" #dialog>
          <div class="row">
            <div class="col-12 pe-0">
              <div class="soft-phone-info text-center"> Wrong/Bad Number</div>
            </div>
            <div class="text-center">
              <input
                class="confirm-btn ms-2"
                type="submit"
                value ="Ok"
             
              />
            </div>
           
          </div>
        </div>
      </div>

      <!-- wrong/invalid number model end -->
    </ng-template>
  </ng-template>
</ng-template>

<div [ngStyle]="{ display: display }">
  <div class="modal" [ngStyle]="{ display: display }">
    <div class="modal-dialog dialer-menu">
      <div class="modal-content" style="width: 185px; height: auto">
        <div class="modal-header menu" style="border-radius: 0">
          <span class="menu-heading">
            <input
              type="text"
              [(ngModel)]="filterVal"
              class="search-box"
              placeholder="Search...."
              (ngModelChange)="applyFilterByField()"
              style="width: 134px; margin: 0 0 0 -6px"
          /></span>
          <span class="close" (click)="onClearFilterVal()">X</span>
        </div>
        <div class="overFlow">
          <div *ngFor="let item of contactNumList" (click)="StartCallActivity(item)">
            <div>
              <p
                style="
                  text-align: left;
                  font-weight: bold;
                  font-size: 0.75rem;
                  line-height: 0.875rem;
                  font-family: Gellix, sans-serif;
                  letter-spacing: 0rem;
                  /* padding-top: 1.25rem; */
                  color: #53565a;
                  opacity: 1;
                  padding: 11px 5px 0 11px;
                "
              >
                {{ item.contactName }}
                <br />
                <span
                  style="
                    text-align: left;
                    font-weight: 500;
                    font-size: 0.75rem;
                    line-height: 0.875rem;
                    font-family: Gellix, sans-serif;
                    letter-spacing: 0rem;
                    color: #53565a;
                    opacity: 1;
                  "
                >
                  {{ item.contactNumber }}
                </span>
              </p>
              <hr class="hrRow" />
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <img
            alt=""
            class="sort-btn"
            [ngClass]="'done-btn-active'"
            (click)="onCloseHandled()"
            src="{{ baseHref }}/assets/images/icon-sort-up.png"
          />
        </div>
      </div>
    </div>
  </div>
</div>

</div>
